<template>
  <Layout>
    <HeaderComponents></HeaderComponents>
    <div class="margin-top-164" style="position: relative;">
      <div style="padding:20px 100px;display: flex;justify-content: space-between ;">
        <Affix :offset-top="164">
          <Sider style="height: 0">
            <Menu theme="light" width="100" :active-name="activeName" @on-select="changeRoute($event)">
              <MenuItem name="workbench">
              <Icon type="md-home" />
              工作台
              </MenuItem>
              <MenuItem name="product_template">
              <Icon type="ios-cube-outline" />
              商品模板
              </MenuItem>
              <MenuItem name="order_list">
              <Icon type="md-reorder" />
              订单管理
              </MenuItem>
              <MenuItem name="wallet_index">
              <Icon type="ios-card-outline" />
              钱包中心
              </MenuItem>
              <MenuItem name="invite_code">
              <Icon type="ios-card-outline" />
              我的邀请
              </MenuItem>
              <MenuItem name="coupon">
              <Icon type="ios-card-outline" />
              优惠券
              </MenuItem>
              <MenuItem name="message">
              <Icon type="md-notifications" />
              消息管理
              </MenuItem>
              <MenuItem name="evaluate">
              <Icon type="md-git-commit" />
              投诉评价
              </MenuItem>
              <MenuItem name="order_artical">
              <Icon type="md-settings" />
              下单流程
              </MenuItem>
              <MenuItem name="setting">
              <Icon type="md-settings" />
              设置中心
              </MenuItem>
            </Menu>
          </Sider>
        </Affix>
        <Content class="content">
          <keep-alive>
            <router-view />
          </keep-alive>
        </Content>

        <!--      <div class="content">-->
        <!--        -->
        <!--      </div>-->
      </div>
    </div>
  </Layout>
</template>

<script>
import HeaderComponents from '../components/header'

export default {
  components: {
    HeaderComponents
  },
  name: 'components-main',
  computed: {
    activeName () {
      return this.$route.name
    }
  },
  data () {
    return {
      messageInfo: '',
      show: true
    }
  },
  created () {
    let vm = this
    this.$request('62cfd88b56ba2', {}).then(res => {
      vm.messageInfo = res.data.data.least_system
    })
  },
  methods: {
    // destroyComponent() {
    //   this.show = false;
    //   this.$forceUpdate();
    //   this.show = true;
    // },
    changeRoute (name) {
      if (name === this.$route.name) {
        this.$eventBus && this.$eventBus.$emit('main-menu-select', name)
        return
      }
      this.$router.push({
        name: name
      })
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
  .content {
    margin-left: 20px;
    background-color: #FFFFFF;
    width: 1020px;
    min-height: 600px;
    border-radius: 3px;
    max-height: 100%;
    overflow-y: auto;
  }
</style>
